import { useState } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import petService from "@fuse/services/petService";

export default function RemovePetDialog({ petId, petName, onClose, onRemoved, onRemove = petService.removeOwnedPet }: {
    petId: string; petName: string; onClose: () => void; onRemoved: () => void;
    onRemove?: (petId: string, reason: string) => Promise<unknown>;
}) {
    const [reason, setReason] = useState("");
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState("");
    const [done, setDone] = useState(false);
    const [auditId, setAuditId] = useState<string | null>(null);
    async function remove() {
        setBusy(true); setError("");
        try {
            const receipt = await onRemove(petId, reason) as { id?: string };
            setAuditId(typeof receipt?.id === "string" ? receipt.id : null);
            setDone(true);
        }
        catch (e: any) { setError(e?.response?.data?.errors?.[0] || e?.message || "Unable to remove this pet. Please try again."); }
        finally { setBusy(false); }
    }
    return <Dialog open onClose={() => !busy && (done ? onRemoved() : onClose())}>
        <DialogTitle>{done ? (reason === "passed_away" ? "We're so sorry for your loss." : `${petName} removed.`) : `Why are you removing ${petName}?`}</DialogTitle>
        <DialogContent>
            {done ? <Typography>{reason === "passed_away" ? "The microchip remains on record and cannot be registered again." : "The pet has been removed."} Auto-renewal is off. This action does not issue a refund.</Typography> :
                <RadioGroup value={reason} onChange={e => setReason(e.target.value)} aria-label="Removal reason">
                    {[["passed_away", "Passed away"], ["rehomed", "Rehomed"], ["added_by_mistake", "Added by mistake"], ["other", "Other"]].map(([value, label]) =>
                        <FormControlLabel key={value} value={value} control={<Radio disabled={busy} />} label={label} />)}
                </RadioGroup>}
            {error && <Alert severity="error">{error}</Alert>}
            {done && auditId && <Typography>Removal reference: {auditId}</Typography>}
        </DialogContent>
        <DialogActions>{done ? <Button onClick={onRemoved}>Close</Button> : <>
            <Button disabled={busy} onClick={onClose}>Go back</Button>
            <Button disabled={!reason || busy} onClick={remove}>{busy ? "Removing…" : `Remove ${petName}`}</Button>
        </>}</DialogActions>
    </Dialog>;
}
